import { createApp } from 'vue'
import App from './App.vue'
import './main.css'

createApp(App).mount('#app')
